import MenuCategory from "./menu_category";
/**
 * Represents a published Menu.
 */
class Menu {
  constructor({
    date,
    categories,
    logo = "",
    banner = "",
    colors = {
      dark: "#ec2727",
      light: "#ec2727"
    },
    establishmentName = "",
    showEstablishmentName = false,
    cardAcepted = true,
    cashAcepted = true,
    onlinePayAcepted = false,
    gPay = null,
    applePay = null,
    canPlaceOrders = false,
    canCallWaiter = true,
    isTest = false,
    locale = false
  }) {
    this.date = date;
    this.categories = categories;
    this.logo = logo;
    this.banner = banner;
    this.colors = colors;
    this.establishmentName = establishmentName;
    this.showEstablishmentName = showEstablishmentName;
    this.cardAcepted = cardAcepted;
    this.cashAcepted = cashAcepted;
    this.onlinePayAcepted = onlinePayAcepted;
    this.gPay = gPay;
    this.applePay = applePay;
    this.canPlaceOrders = canPlaceOrders;
    this.canCallWaiter = canCallWaiter;
    this.isTest = isTest;
    this.locale = locale;
  }

  toMap() {
    return {
      date: this.date,
      categories: this.categories
        ? this.categories.map(category => category.toMap())
        : []
    };
  }

  static fromMap(map) {
    let categories = map.categories
      ? map.categories.map(category => MenuCategory.fromMap(category))
      : [];

    return new Menu({ ...map, categories: categories });
  }
  slugify(str) {
    var map = {
      "-": " ",
      a: "á|à|ã|â|À|Á|Ã|Â",
      e: "é|è|ê|É|È|Ê",
      i: "í|ì|î|Í|Ì|Î",
      o: "ó|ò|ô|õ|Ó|Ò|Ô|Õ",
      u: "ú|ù|û|ü|Ú|Ù|Û|Ü",
      c: "ç|Ç",
      n: "ñ|Ñ"
    };

    str = str.toLowerCase();

    for (var pattern in map) {
      str = str.replace(new RegExp(map[pattern], "g"), pattern);
    }

    return str;
  }
  filter(search) {
    if (search) {
      let menuCopy = this.clone();
      menuCopy.categories.forEach(category => {
        category.products = category.products.filter(product => {
          let isDescriptionMatch = product.description
            ? this.slugify(product.description.toLowerCase()).includes(
                this.slugify(search.toLowerCase())
              )
            : false;
          return (
            this.slugify(product.name.toLowerCase()).includes(
              this.slugify(search.toLowerCase())
            ) || isDescriptionMatch
          );
        });
      });

      menuCopy.categories = menuCopy.categories.filter(category => {
        return category.products.length > 0;
      });
      menuCopy.categories = menuCopy.categories.sort(function(a, b) {
        console.log("acas");
        return a.index - b.index;
      });
      return menuCopy;
    }
    return this;
  }

  clone() {
    return this.constructor.fromMap(this.toMap());
  }
}

export default Menu;
